import { Card } from "react-bootstrap";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis } from "recharts";
import { COLOR, STYLE } from "../../../config/constraits";
import { useTranslation } from "react-i18next";
import { useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import ChartShareActions from "../../../components/ChartShareActions";
import { TopicStatistics } from "../types";

interface CustomizedAxisTickProps {
    x: number;
    y: number;
    payload: {
        value: string | number;
    };
}

interface TopicsBarChartProps {
    topics: TopicStatistics[]
}

const CustomizedAxisTick: React.FC<CustomizedAxisTickProps> = ({ x, y, payload }) => {
    return (
        <g transform={`translate(${x},${y})`}>
            <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-35)">
                {payload.value}
            </text>
        </g>
    );
};

export default function TopicsBarChart({ topics }: TopicsBarChartProps) {
    const { t } = useTranslation('dashboard');
    const selectedFilters = useSelector((state: RootState) => state.filters.dashboard.selectedFilters);
    const feelingchartRef = useRef<HTMLDivElement>(null);

    return (
        <div ref={feelingchartRef}>
            <Card
                style={{
                    backgroundColor: "#F5F5F5",
                    border: "none",
                    borderRadius: STYLE.BORDER_RADIUS,
                    height: "400px",
                    position: "relative" // Agregar posición relativa
                }}
                className="p-4 d-flex justify-content-center align-items-center text-center"
            >
                {/* Botones en la esquina superior derecha */}
                <div style={{ position: "absolute", top: "10px", right: "10px" }}>
                    <ChartShareActions
                        chartRef={feelingchartRef}
                        title={t("dashboard:trendingTopicsDistributionComment")}
                        filters={selectedFilters}
                        t={t}
                    />
                </div>

                <h4>{t("dashboard:trendingTopicsDistributionComment")}</h4>

                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        width={500}
                        height={300}
                        data={topics}
                        margin={{
                            top: 20,
                            right: 30,
                            left: 70,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} />
                        <XAxis dataKey="name" angle={60} height={120} tick={({ x, y, payload }) => <CustomizedAxisTick x={x} y={y} payload={payload} />} />
                        <Tooltip />
                        <Bar name="Comentaris negatius" dataKey="negativeComments" stackId="a" fill={COLOR.VERMELL} />
                        <Bar name="Comentaris neutres" dataKey="neutralComments" stackId="a" fill={COLOR.TARONJA} />
                        <Bar name="Comentaris positius" dataKey="positiveComments" stackId="a" fill={COLOR.VERD} />
                    </BarChart>
                </ResponsiveContainer>
            </Card>
        </div>
    );
}
